import { Input } from '../../../design-system';
import StateSelect from '../../../components/StateSelect';

// Controlled address field group, shared by the GSTIN editor (both the detail
// modal and the create form) for PPOB / APOB entry.
//
// State and state code are ONE field here, not two. They used to be free text
// side by side, which let an address be saved as "Maharashtra / 06" — and since
// the code is what picks CGST+SGST vs IGST, that mismatch reaches an invoice
// with nothing on screen having looked wrong.
function AddressFields({ value, onChange, legend }) {
  const set = (field, v) => onChange({ ...value, [field]: v });
  return (
    <fieldset className="address-fieldset">
      <legend>{legend}</legend>
      <div className="form-row">
        <Input label="Address line 1" value={value.line1 || ''} onChange={(e) => set('line1', e.target.value)} />
        <Input label="Address line 2" value={value.line2 || ''} onChange={(e) => set('line2', e.target.value)} />
      </div>
      <div className="form-row">
        <Input label="City" value={value.city || ''} onChange={(e) => set('city', e.target.value)} />
        <StateSelect
          code={value.stateCode}
          name={value.state}
          // Both fields move together — that is the whole point of the picker.
          onChange={({ stateCode, state }) => onChange({ ...value, stateCode, state })}
        />
        <Input label="Pincode" value={value.pincode || ''} onChange={(e) => set('pincode', e.target.value)} maxLength={6} />
      </div>
    </fieldset>
  );
}

export const emptyAddress = () => ({ line1: '', line2: '', city: '', state: '', stateCode: '', pincode: '' });

export default AddressFields;
